import moment from 'moment';

export const _getDateTime = (val, format) => {
  try {
    const date = moment.utc(val).local();

    return date.format(format);
  } catch (error) {}
};
